import { registerComponent } from "lib/components";
import { DateTimePickerApp } from "./main";

registerComponent({ DateTimePickerApp });
